'use strict'

/**
 * @module search
 */
import { getLang } from '../utils/utils'
import searchFiltersStorage from './searchFiltersStorage'

const LANG = !getLang() ? 'fr' : getLang().substring(1)
const API = {
  FORM: {
    fr: 'recherchez-votre-camping/recherche-avancee',
    uk: 'find-your-campsite/advanced-search',
    nl: 'zoek-een-camping/op-criteria-zoeken',
    de: 'suchen-sie-ihren-campingplatz/per-kriterien-suchen',
    es: 'busque-su-camping/busqueda-camping-por-criterios'
  },
  STATS: '/api/which-campsite/result-stats'
}

const DOM = {
  EL: {
    EMPTY_FILTERS: '<form method="post" action="" class="adv-form"></form>'
  },
  ID: {
    STATE_SELECT: 'region',
    COUNTY_SELECT: 'department',
    MOB_STATE_SELECT: 'select-mob-state',
    MOB_COUNTY_SELECT: 'select-mob-county',
    ADV_SCH_BLOC: 'adv-search-bloc',
    REGION: "region",
    TAILLE: "taille",
    RANKING: "ranking",
    PERIOD_DROPDOWN: "period-dropdown",
    SITUATION_DROPDOWN: "situation-dropdown",
    AQUA_DROPDOWN: "aqua-dropdown",
    SPORT_DROPDOWN: "sport-dropdown",
    CHILDREN_DROPDOWN: "children-dropdown",
    LEISURE_DROPDOWN: "leisure-dropdown",
    ANIMATION_DROPDOWN: "animation-dropdown",
    CONFORT_DROPDOWN: "confort-dropdown",
    FOOD_DROPDOWN: "food-dropdown",
    SERVICE_DROPDOWN: "service-dropdown",
    HANDICAP_DROPDOWN: "handicap-dropdown",
    CAMPING_CAR_DROPDOWN: "campingCar-dropdown",
    QUALITY_DROPDOWN: "quality-dropdown",
    TYPE_DROPDOWN: "type-dropdown",
    FEDERATION_DROPDOWN: "federation-dropdown",
    COUNTER: 'campsite-counter'
  },
  CLASS: {
    FILTERS_LIST: 'adv-form',
    STICKY_CONTAINER: 'result-container',
    STICKY: 'sticky',
    LOADER: 'loader',
    ACTIV: 'activ',
    HIDDEN: 'is-hidden',
    RESET_FILTERS: 'lk-reset',
    HEADER: 'cf-header',
    ADV_SEARCH: 'adv-sch'
  },
  STYLE: {
    BLOCK: 'block',
    NONE: 'none'
  },
  ATTRIBUTE: {
    URL: 'data-url',
    SELECTED: 'selected',
    FILTER_LABEL: 'data-filter-label',
    FILTER_VALUE: 'data-filter-value',
    RESULTS_COUNT: 'data-search-count',
    CATEGORY: 'data-category',
    FILTER_CATEGORY: 'data-filter-category'
  },
  SELECTOR: {
    SEARCH_CONTAINER: '.filters-sch',
    FILTERS_RECAP_LIST: '.items-filters-bar',
    FILTERS_RECAP_CONTAINER: '.items-filters-bloc',
    FILTERS_LIST: '.adv-form',
    STICKY_CONTAINER: '.result-container',
    GO_TO_RESULTS: '.submit-btn-bloc a',
    DEPARTMENT: 'select#department'
  }
}

const checkboxesFiltersDropdown = [
  DOM.ID.PERIOD_DROPDOWN,
  DOM.ID.SITUATION_DROPDOWN,
  DOM.ID.AQUA_DROPDOWN,
  DOM.ID.SPORT_DROPDOWN,
  DOM.ID.CHILDREN_DROPDOWN,
  DOM.ID.LEISURE_DROPDOWN,
  DOM.ID.ANIMATION_DROPDOWN,
  DOM.ID.FOOD_DROPDOWN,
  DOM.ID.CONFORT_DROPDOWN,
  DOM.ID.SERVICE_DROPDOWN,
  DOM.ID.HANDICAP_DROPDOWN,
  DOM.ID.CAMPING_CAR_DROPDOWN,
  DOM.ID.QUALITY_DROPDOWN,
  DOM.ID.TYPE_DROPDOWN,
  DOM.ID.FEDERATION_DROPDOWN,
]

const selects = [
  DOM.ID.STATE_SELECT, DOM.ID.COUNTY_SELECT, DOM.ID.MOB_STATE_SELECT, DOM.ID.MOB_COUNTY_SELECT
]

export default {

  /**
   * @description Initialise search
   * @returns {undefined}
   */
  init() {
    // Reinitialize/empty search filters if on a thematic page
    if (document.querySelector('main[data-thematic-id]')) {
      searchFiltersStorage.reset()
    }
    //Check if advanced search full page is called
    document.getElementsByClassName(DOM.CLASS.ADV_SEARCH)[0] ? this.bind() : this.fetchAdvancedSearchHTML()
  },

  /**
   * @description Bind events on search elements
   * @returns {undefined}
   */
  bind() {
    selects.map(select => {
      const elt = document.getElementById(select)
      elt && elt.bindEvent('change', this.onSelectChange.bind(this))
    })

    checkboxesFiltersDropdown.map(dropdown => {
      const elt = document.getElementById(dropdown)
      elt && elt.bindEvent('click', this.showCheckboxes.bind(this))
    })

    document.getElementsByClassName(DOM.CLASS.FILTERS_LIST).item(0)
      .bindEvent('change', '[type=checkbox]', e => this.updateFromCheckbox(e))
    document.getElementsByClassName(DOM.CLASS.FILTERS_LIST).item(0)
      .bindEvent('change', 'select', e => this.updateFromSelect(e))
    document.querySelector(DOM.SELECTOR.FILTERS_RECAP_LIST)
      .bindEvent('click', 'li', e => this.triggerFromRecap(e))
    document.querySelectorAll(DOM.SELECTOR.GO_TO_RESULTS).bindEvent('click', this.redirect.bind(this))
    document.querySelectorAll(`input[data-category="category"]`)
        .bindEvent('click', this.checkAllSubcategories.bind(this))
    document.querySelector('nav.top-nav form.nav-search button[type="submit"]')
        .bindEvent('click', this.submitMobileSearchForm.bind(this))

    document.querySelector('.advanced-search-btn').bindEvent('click', this.refreshForm.bind(this))
  },

  checkAllSubcategories(e) {
    e.currentTarget.closest('li').querySelectorAll('ul li span input[type="checkbox"]').forEach(item => {
      item.checked = e.currentTarget.checked
    })
  },

  /**
   * @description Display loader and call functions
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  onSelectChange(e) {
    let current = e.currentTarget
    if (current.id === 'department') {
      const region = current.selectedOptions.item(0).dataset.region
      const pos = document.querySelector(`option[value="${region}"]`).index
      if (pos) {
        document.querySelector('select#region').selectedIndex = pos
      }
    } else if (current.id === 'region') {
      document.querySelector('select#department').selectedIndex = 0
    } else if (current.id === 'select-mob-state') {
      document.querySelector('select#select-mob-county').selectedIndex = 0
    } else if (current.id === 'select-mob-county') {
      const region = current.selectedOptions.item(0).dataset.state
      const pos = document.querySelector(`option[value="${region}"]`).index
      if (pos) {
        document.querySelector('select#select-mob-state').selectedIndex = pos
      }
    }
    this.updateSearchFiltersStorage(current)
    const container = current.closest(DOM.SELECTOR.SEARCH_CONTAINER)
    container && container.classList.add(DOM.CLASS.LOADER)
    this.resetSelect(current)
  },

  submitMobileSearchForm(e) {
    e.preventDefault()
    const form = e.currentTarget.form
    const formdata = new FormData(form)

    let url = searchFiltersStorage.generateUrl(form.action, 'advancedSearch')
    if (formdata.get('inp-keyw')) {
      url += '?inp-keyw=' + formdata.get('inp-keyw')
    }
    window.location = url
  },

  /**
   * @description Reset next select siblings
   * @param {Element} select
   * @returns {undefined} none
   */
  resetSelect(select) {
    let current = select
    while (current.nextElementSibling) {
      current.nextElementSibling.firstElementChild.setAttribute(DOM.ATTRIBUTE.SELECTED, '')
      current = current.nextElementSibling
    }
  },

  /**
   * @description add filters params before redirecting
   * @param {object} e MouseEvent
   * @returns {undefined}
   */
  redirect(e) {
    e.preventDefault()
    window.location = searchFiltersStorage.generateUrl(e.currentTarget.href, 'advancedSearch')
  },

  /**
   * @description Fetch for initial display of HTML advancedSearch dropdown
   * @returns {undefined}
   */
  fetchAdvancedSearchHTML() {
    const PREFIX = LANG === 'fr'  ? ''  :  getLang()
    const LANG_URL = `${PREFIX}/${API.FORM[LANG]}?search-bar=true`
    const options = {method: 'get'}

    fetch(`${LANG_URL}`, options).then(response => {
      return response.text()
    }).catch((error) => {
      console.log(error)
    }).then(text => {
      document.getElementById(DOM.ID.ADV_SCH_BLOC).innerHTML = text
      this.refreshForm()
      this.bind()
    })
  },

  /**
   * @description Update filter object or sport object list from checkbox
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  updateFromCheckbox(e) {
    const currentTarget = e.customCurrentTarget
    this.updateSearchFiltersStorage(currentTarget)
    this.refreshForm()
  },

  /**
   * @description toggle one filter state
   * @param {object} element
   * @returns {undefined} none
   *
   */
  toggleOneFilter(element) {
    const action = element.checked;
    const filterString = this.getFilterString(element)
    const filterValue = this.getFilterValue(element)

    if (action) {
      element.classList.add(DOM.CLASS.ACTIV)
      this.filters.push(filterValue)
      if (this.filters.includes(null)) {
        this.filters = this.unshiftNullFromArray(this.filters)
      }
    } else {
      element.classList.remove(DOM.CLASS.ACTIV)
      this.filters.splice(this.filters.indexOf(filterValue), 1)
    }
    if (filterValue != null) {
      this.updateFiltersRecap(filterString, filterValue, action)
    }
  },

  /**
   * @description Update filter object from select
   * @param {object} e MouseEvent
   * @returns {undefined} none
   */
  updateFromSelect(e) {
    const currentTarget = e.customCurrentTarget.selectedOptions.item(0)
    this.updateSearchFiltersStorage(currentTarget)
    this.refreshForm()
  },

  /**
   * @description update number of results from the API_FILTERS response
   * @param {number} count number of results
   * @returns {undefined}
   */
  updateStats() {
    const resultsContainer = document.getElementsByClassName(DOM.CLASS.STICKY_CONTAINER).item(0)
    this.toggleLoader(resultsContainer, true)

    const filters = []
    Object.entries(searchFiltersStorage.getAll()).forEach(entry => {
      if (entry[1].length > 0) {
        if (Array.isArray(entry[1])) {
          entry[1].forEach(item => filters.push(entry[0] + '=' + item))
        } else {
          filters.push(entry[0] + '=' + entry[1])
        }
      }
    })

    fetch(`${API.STATS}?${filters.join('&')}`).then(response => {
      return response.json()
    })
      .catch(() => {
        this.toggleLoader(resultsContainer, false)
      })
      .then(json => {
        document.getElementById(DOM.ID.COUNTER).innerHTML = json.total_results
        this.toggleLoader(resultsContainer, false)
      })
      .catch(() => {
        this.toggleLoader(resultsContainer, false)
      })
  },

  /**
 * @description if filters clicked from DOM.SELECTOR.FILTERS_RECAP_LIST, trigger click on filters
 * from DOM.CLASS.FILTERS_LIST
 * @param {object} e MouseEvent
 * @returns {undefined} none
 */
  triggerFromRecap(e) {
    const filterFromRecap = e.customCurrentTarget
    const filterFromList = document.getElementsByClassName(DOM.CLASS.FILTERS_LIST).item(0)
      .querySelector(
        `[${DOM.ATTRIBUTE.FILTER_VALUE}="${filterFromRecap.getAttribute(DOM.ATTRIBUTE.FILTER_VALUE)}"]`
      )

    e.stopPropagation()

    switch (filterFromList.tagName) {
      case 'INPUT':
        filterFromList.checked = false
        this.updateFromCheckbox({ customCurrentTarget: filterFromList })
        break
      case 'OPTION':
        filterFromList.parentNode.selectedIndex = 0
        this.updateFromSelect({ customCurrentTarget: filterFromList.parentNode })
        break
      default:
    }
  },

  /**
   * @description show or hide loader
   * @param {Element} target element which will display the loader
   * @param {boolean} state show or hide
   * @returns {undefined}
   */
  toggleLoader(target, state) {
    if (!target) {
      return
    }
    if (state) {
      target.classList.add(DOM.CLASS.LOADER)
    } else {
      target.classList.remove(DOM.CLASS.LOADER)
    }
  },

  /**
   * @description return filter's name, set in DOM.ATTRIBUTE.FILTER_LABEL attribute
   * @param {object} element filter
   * @returns {string} filter name
   */
  getFilterString(element) {
    return element.getAttribute(DOM.ATTRIBUTE.FILTER_LABEL)
  },

  /**
   * @description return filter's value, set in DOM.ATTRIBUTE.FILTER_VALUE attribute
   * @param {object} element filter
   * @returns {string} filter value
   */
  getFilterValue(element) {
    return element.getAttribute(DOM.ATTRIBUTE.FILTER_VALUE)
  },

  /**
   * @description return current element category name
   * @param {object} element filter
   * @returns {string} filter value
   */
  getCategory(element) {
    return element.name
  },

  /**
   * @description return one category sport list
   * @param {string} category
   * @returns {array} sport input
   */
  getOneCategorySports(category) {
    return document.querySelectorAll(`${DOM.SELECTOR.FILTERS_LIST} input[data-filter-category="${category}"]`)
  },

  /**
   * @description create filter element and append to DOM.SELECTOR.FILTERS_RECAP_LIST
   * @param {string} label filter name
   * @param {string} value filter value
   * @returns {undefined} none
   */
  addToFiltersRecap(label, value) {
    const recapList = document.querySelector(DOM.SELECTOR.FILTERS_RECAP_LIST)
    if (recapList.querySelector(`[${DOM.ATTRIBUTE.FILTER_VALUE}="${value}"]`)) {
      return
    }
    let itemLi = document.createElement('li')
    itemLi.setAttribute(DOM.ATTRIBUTE.FILTER_VALUE, value)
    let itemA = document.createElement('a')
    itemA.innerText = label
    itemLi.appendChild(itemA)
    recapList.appendChild(itemLi)
  },

  /**
   * @description add or remove filters from DOM.SELECTOR.FILTERS_RECAP_LIST
   * @returns {undefined} none
   */
  updateFiltersRecap() {

    const filtersRecap = document.querySelector(DOM.SELECTOR.FILTERS_RECAP_LIST)
    filtersRecap.innerHTML = ''

    Object.entries(searchFiltersStorage.getAll()).forEach(entry => {
      if (entry[1].length === 0 || entry[1] === '') {
        return
      }
      const name = entry[0] === 'state' ? 'region' : entry[0]
      let elts = document.querySelectorAll('[name="' + name + '"]')
      if (elts.length === 1) {
        if (!elts[0].options[elts[0].selectedIndex]) return
        const dataset = elts[0].options[elts[0].selectedIndex].dataset
        this.addToFiltersRecap(dataset.filterLabel, dataset.filterValue)
      } else {
        elts.forEach(elt => {
          if (elt.checked) {
            this.addToFiltersRecap(elt.dataset.filterLabel, elt.dataset.filterValue)
          }
        })
      }
    })
  },

  /**
   * @description show DOM.SELECTOR.FILTERS_RECAP_LIST if at least one filter selected, hide if none
   * selected
   * @returns {undefined} none
   */
  toggleFiltersRecap() {
    const filtersRecap = document.querySelector(DOM.SELECTOR.FILTERS_RECAP_LIST)
    const filtersRecapContainer = filtersRecap.closest(DOM.SELECTOR.FILTERS_RECAP_CONTAINER)
    if (filtersRecap.childElementCount) {
      filtersRecapContainer.classList.remove(DOM.CLASS.HIDDEN)
    } else {
      filtersRecapContainer.classList.add(DOM.CLASS.HIDDEN)
    }
  },

  /**
   * @description Remove "null" from array
   * @param {array} array
   * @returns
   */
  unshiftNullFromArray(array) {
    return array.filter(function (value) {
      return value !== null;
    });
  },

  /**
   * @description update department list according to selected region
   * @param {object} e
   * @returns {undefined} none
   */
  updateDptList() {
    const selectedRegionElt = document.getElementById(DOM.ID.STATE_SELECT).selectedOptions.item(0)
    if (!selectedRegionElt) return // Might be the case when clicking a region on the search map from the search bar
    const selectedRegion = selectedRegionElt.value
    if (!selectedRegion) {
      document.querySelectorAll(`${DOM.SELECTOR.DEPARTMENT} option`)
        .forEach(item => item.style.display = DOM.STYLE.BLOCK)
    } else {
      const selectedDepartment = document.getElementById(DOM.ID.COUNTY_SELECT).selectedOptions.item(0)
      if (selectedDepartment && selectedDepartment.value !== '' && selectedDepartment.dataset.region !== selectedRegion) {
        this.setFiltersStorageValue('department', '')
        return
      }

      document.querySelectorAll(`${DOM.SELECTOR.DEPARTMENT} option[data-region]`).forEach(item => item.style.display = DOM.STYLE.NONE)
      document.querySelectorAll(`${DOM.SELECTOR.DEPARTMENT} option[data-region="${selectedRegion}"]`)
        .forEach(item => item.style.display = DOM.STYLE.BLOCK)
    }
  },

  /**
   * @description Show hide dropdown callback on bind events
   * @param {event} e
   * @returns {undefined} none
   * How to use in DOM:
   * - on fire event element id="myIdFired-dropdown"
   * - on dropdown content element  id=myIdFired  and class="close"
  */
  showCheckboxes(e) {
    const id = e.currentTarget.id.split('-')[0]
    const checkboxesBlock = document.getElementById(id);
    const expanded = !checkboxesBlock.classList.contains(DOM.CLASS.HIDDEN)

    if (!expanded) {
      checkboxesBlock.style.display = DOM.STYLE.BLOCK;
      checkboxesBlock.classList.remove(DOM.CLASS.HIDDEN)
    } else {
      checkboxesBlock.style.display = DOM.STYLE.NONE;
      checkboxesBlock.classList.add(DOM.CLASS.HIDDEN)
    }
  },

  updateSearchFiltersStorage(elt) {
    const formData = new FormData(elt.form)
    searchFiltersStorage.set(this.normalizeFormData(formData, elt))
  },

  setFiltersStorageValue(key, value) {
    searchFiltersStorage.setValue(key, value)
    this.refreshForm()
  },

  normalizeFormData(formData, elt) {
    const o = {}
    for (let k of formData.keys()) {
      if (k === 'inp-keyw') {
        continue
      }
      const values = formData.getAll(k)
      if (k === 'state') k = 'region'
      else if (k === 'county') k = 'dpt'
      if (k === 'region' || k === 'dpt') {
        const select = elt.form.querySelector('select[name="'+k+'"]')
        let i18nSlug = ''
        if (select.getAttribute('id').indexOf('select-mob') !== -1) {
          i18nSlug = select.selectedOptions[0].dataset.url.split('/').reverse()[0]
        } else {
          i18nSlug = select.selectedOptions[0].dataset.i18nSlug
        }
        if (i18nSlug) {
          o[k+'_i18n'] = i18nSlug
        }
      }
      if (k.indexOf('[]') === -1) {
        o[k] = values[0]
      } else {
        o[k] = values
      }
    }
    return o
  },

  refreshForm() {
    this.restoreSelectBoxes()
    this.restoreCheckBoxes()
    Object.entries(searchFiltersStorage.getAll()).forEach(entry => {
      const name = entry[0] === 'state' ? 'region' : entry[0]
      let elts = document.querySelectorAll('[name="' + name + '"]')
      if (elts.length === 0) {
        return
      }
      if (elts.length === 1) {
        elts[0].value = entry[1]
      } else {
        this.updateSelectBox(elts.item(0).closest('.multiselect'), entry)
        elts.forEach(elt => {
          if (Array.isArray(entry[1])) {
            entry[1].forEach(value => {
              if (elt.value === value) {
                elt.checked = true
              }
            })
          } else {
            elt.value = entry[1]
          }
        })
      }
    })
    this.updateDptList()
    this.updateFiltersRecap()
    this.updateSportCategories()
    this.updateStats()
  },

  restoreSelectBoxes() {
    document.querySelectorAll('.selectBox select').forEach(select => {
      select.querySelectorAll('option').forEach(option => {
        if (option.hasAttribute('label')) {
          option.remove()
        }
      })
    })
  },

  restoreCheckBoxes() {
    document.querySelectorAll('.adv-form input[type="checkbox"]').forEach(elt => elt.checked = false)
  },

  updateSelectBox(elt, entry) {
    if (!elt) {
      return
    }
    const select = elt.querySelector('.selectBox select')
    const option = document.createElement('option')
    const labels = entry[1].map(item => {
      return document.querySelector(`input[type="checkbox"][value="${item}"]`).dataset.filterLabel
    })
    option.label = labels.join(', ')
    select.appendChild(option)
    option.selected = true
  },

  updateSportCategories() {
    document.querySelectorAll(`input[data-category="category"]`).forEach(category => {
      category.checked = true
      category.closest('li').querySelector('ul').querySelectorAll('input').forEach(input => {
        if (input.checked === false) {
          category.checked = false
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/search.js